import { t } from '@lingui/macro'
import { useAppSelector } from '@/redux/rootReducer'
import { selectCpxCard } from '@/redux/reducers/dmp-connect.reducer'
import { useDmpConnectSession } from '../model/useDmpConnectSession'
import { DmpConnectError } from './DmpConnectError'
import { DmpConnectLoading } from './DmpConnectLoading'
import { SelectCPxCard } from './SelectCPxCard'

export function DmpConnectSession({ children }: { children: React.ReactNode }) {
  const cpxCard = useAppSelector(selectCpxCard)
  const cpxCardReaderName = useAppSelector((state) => state.dmpConnect.cpxCardReaderName)

  const { error, isLoadingSession } = useDmpConnectSession()

  if (error) {
    return <DmpConnectError error={error} />
  }

  if (isLoadingSession) {
    return <DmpConnectLoading message={t`Loading session...`} />
  }

  if (!cpxCard) {
    return <SelectCPxCard initialCardReaderName={cpxCardReaderName} />
  }

  return <>{children}</>
}
